
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

export const firebaseConfig = {
    apiKey: "AIzaSyCX5frlY7W61LC-K9ALJGw8VNiCRfL77Sc",
    authDomain: "andas-afa43.firebaseapp.com",
    projectId: "andas-afa43",
    storageBucket: "andas-afa43.appspot.com",
    messagingSenderId: "1048676479305",
    appId: "1:1048676479305:web:a5da069bce37b5953a2a98",
    measurementId: "G-H4SFT43KN9"
  };
  


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export { app, analytics, auth };